import { Injectable } from '@angular/core';
import { tap, catchError } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { BoToastrService } from '../../shared';
import { API } from '../config/api';
import { SUCCESS } from '../../../@shared/constants';
import { ErrorResponse } from '../config/common';
import { GetRoadRateRequest, ImportRoadRateRequest } from './road-rate.DTO';
import { environment } from '../../../environments/environment';

@Injectable()
export class RoadRateService {
    public baseUrl = environment.baseUrl;
    constructor(
        private _http: HttpClient,
        private _toastr: BoToastrService
    ) { }
    
    public getRoadRate(model: GetRoadRateRequest) {
        return this._http.post(`${API.ROAD_RATE.GET_ROAD_RATE}`, model);
    }

    public update(model: any) {
        return this._http.put(`${API.ROAD_RATE.UPDATE}`, model)
            .pipe(
                tap(() => {
                    this._toastr.successCode(SUCCESS.UPDATE_ROAD_RATE);
                }),
                catchError((err: ErrorResponse) => {
                    this._toastr.errors(err.error.errors);
                    throw err;
                })
            );
    }

    public importRoadRate(model: ImportRoadRateRequest) {
        const formData = new FormData();
        formData.append('file', model.file);
        formData.append('NorskGlobalID', model.norskGlobalID);
        return this._http.post(`${API.ROAD_RATE.IMPORT_ROAD_RATE}`, formData)
            .pipe(
                tap(() => {
                    this._toastr.successCode(SUCCESS.IMPORT_ROAD_RATE);
                }),
                catchError((err: ErrorResponse) => {
                    this._toastr.errors(err.error.errors);
                    throw err;
                })
            );
    }
    
    
}
